import React from 'react';
import {dropdownFillBlack} from 'assets/images/images';
import {Accordion} from '../../../components';
import {DetailRow} from './DetailRow';

function BehavioralAndDevice({data = {}}) {
  const {device_summary = {}, usage_behavior = {}} = data;

  return (
    <div className="bg-white rounded-xl py-4 flex flex-col gap-4">
      <div className="px-6 flex flex-col gap-1">
        <h4 className="text-deepBlue font-medium">
          Behavioral & Device Information
        </h4>
      </div>

      <div className="px-3 flex flex-col gap-4">
        <Accordion
          customTitleSize="text-tiny text-deepBlue font-medium leading-[16px]"
          customClasses="border border-[#F3F4F7] rounded-[12px]"
          customPadding="p-3 flex-col md:flex-row h-11 !items-start"
          customImg={dropdownFillBlack}
          title="Device Summary"
        >
          <div className="mt-1">
            <DetailRow
              label="Active Devices"
              value={device_summary.active_devices}
            />
            <DetailRow
              label="Primary Device"
              value={device_summary.primary_device}
            />
            <DetailRow
              label="Unique IPs (30d)"
              value={device_summary.unique_ips_30d}
            />
          </div>
        </Accordion>

        <Accordion
          customTitleSize="text-tiny text-deepBlue font-medium leading-[16px]"
          customClasses="border border-[#F3F4F7] rounded-[12px]"
          customPadding="p-3 flex-col md:flex-row h-11 !items-start"
          customImg={dropdownFillBlack}
          title="Usage Behavior"
        >
          <div className="mt-1">
            <h5 className="text-xs text-[#5C688E] font-bold tracking-wider uppercase pt-1 pb-4">
              LOGIN FREQUENCY:
            </h5>
            <DetailRow
              label="Average logins per day or week."
              value={usage_behavior.average_logins_per_day_or_week}
            />

            <h5 className="text-xs text-[#5C688E] font-bold tracking-wider uppercase pt-4 pb-4 border-t border-[#F6F7F9]">
              SECURITY HYGIENE
            </h5>
            <DetailRow
              label="Days Since Last Password Change"
              value={usage_behavior.days_since_last_password_change}
            />
            <DetailRow
              label="Days Since Last PIN Change"
              value={usage_behavior.days_since_last_pin_change}
            />

            <h5 className="text-xs text-[#5C688E] font-bold tracking-wider uppercase pt-4 pb-4 border-t border-[#F6F7F9]">
              RECENT DEVICE EVENTS
            </h5>
            <DetailRow
              label="List of significant access events"
              value={usage_behavior.list_of_significant_access_events}
            />
          </div>
        </Accordion>

        <Accordion
          customTitleSize="text-tiny text-deepBlue font-medium leading-[16px]"
          customClasses="border border-[#F3F4F7] rounded-[12px]"
          customPadding="p-3 flex-col md:flex-row h-11 !items-start"
          customImg={dropdownFillBlack}
          title="Behavioral Flags"
        >
          <div className="mt-1">
            <p className="text-small text-[#858DAA] capitalize py-2 border-[0.5px] border-transparent border-b-[#F6F7F9]">
              Multiple device switches in 24 hours
            </p>
            <p className="text-small text-[#858DAA] capitalize py-2 border-[0.5px] border-transparent border-b-[#F6F7F9]">
              High-risk IP ASN observed
            </p>
          </div>
        </Accordion>
      </div>
    </div>
  );
}

export default BehavioralAndDevice;
